import React from "react";
import { Col, Container, Row } from "reactstrap";
import "./ExerciseDonePage.scss"
import {Trans, withTranslation} from "react-i18next";
import ExerciseHeader from "./header/ExerciseHeader";

class ExerciseErrorPage extends React.Component {
  constructor(props) {
    super(props);
    // const idOfExercise = props.match.params.id
    this.state = {};
  }


  render() {
    let serverError = this.props.location.state
    const status = this.props.match.params.status;

    return (
      <div className={"done-page"}>
        <ExerciseHeader nameOfExercise={""}/>
        <Container className={"container-done"}>
          <Row><Col><Trans i18nKey="page.error.header">Něco se pokazilo</Trans></Col></Row>
          <Row><Col><Trans i18nKey="page.error.error">Chyba</Trans>: {status}</Col></Row>
          <Row><Col>{serverError}</Col></Row>
        </Container>
      </div>
    );
  }

}

export default withTranslation()(ExerciseErrorPage);
